function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React, { useCallback, useState } from 'react';
import axios from 'axios';
import { Flex, IconButton, Text, Icon, icons } from '@tapresearch/ui/components';
import { rem } from '@mantine/core';
var ORGANIZATION_ROLE_CUSTOMER_SUCCESS = 3;
export var OrganizationalContextBanner = function(param) {
    var user = param.user, children = param.children;
    var _user_organization_membership, _user_organization;
    var _useState = _sliced_to_array(useState(false), 2), isLeaving = _useState[0], setIsLeaving = _useState[1];
    var onExitContext = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    setIsLeaving(true);
                    return [
                        4,
                        axios.post('/organizations/current_organization/leave')
                    ];
                case 1:
                    _state.sent();
                    window.location.assign('/organizations/manage');
                    return [
                        2
                    ];
            }
        });
    }), []);
    var isManaging = (user === null || user === void 0 ? void 0 : user.is_ops) && (user === null || user === void 0 ? void 0 : (_user_organization_membership = user.organization_membership) === null || _user_organization_membership === void 0 ? void 0 : _user_organization_membership.role) === ORGANIZATION_ROLE_CUSTOMER_SUCCESS;
    if (!isManaging || !(user === null || user === void 0 ? void 0 : (_user_organization = user.organization) === null || _user_organization === void 0 ? void 0 : _user_organization.company_name)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Flex, {
        flexDir: 'column',
        bg: 'fuschia.50',
        color: 'gray.800',
        fontWeight: 'medium',
        position: 'relative',
        w: 'calc(100% - 20px)',
        m: '0 auto',
        rounded: 'md',
        mt: 4,
        py: 4,
        pl: 4,
        pr: 1,
        borderTop: '2px solid',
        borderColor: 'fuschia.500',
        borderTopRadius: '4px'
    }, /*#__PURE__*/ React.createElement(Flex, {
        align: "center"
    }, /*#__PURE__*/ React.createElement(Flex, {
        flex: 1
    }, /*#__PURE__*/ React.createElement(Flex, {
        flexDir: "column",
        w: "full",
        mr: 2,
        fontWeight: "medium",
        color: "fuschia.600",
        fontSize: "md"
    }, /*#__PURE__*/ React.createElement(Flex, {
        align: "center"
    }, /*#__PURE__*/ React.createElement(Icon, {
        boxSize: 6,
        mr: 2,
        icon: icons.io5.ShieldCheckmarkOutline
    }), "Managing"), /*#__PURE__*/ React.createElement(Flex, {
        mt: 3,
        align: "center"
    }, /*#__PURE__*/ React.createElement(Text, {
        color: "gray.900",
        fontWeight: "normal",
        sx: {
            fontSize: rem(14)
        }
    }, user.organization.company_name)))), isManaging && /*#__PURE__*/ React.createElement(Flex, {
        flex: 0,
        justify: "flex-end"
    }, /*#__PURE__*/ React.createElement(IconButton, {
        "aria-label": "Exit context",
        size: "md",
        colorScheme: "fuschia",
        variant: "ghost",
        color: "fuschia.600",
        isLoading: isLeaving,
        icon: /*#__PURE__*/ React.createElement(Icon, {
            m: 0,
            boxSize: 5,
            icon: icons.fi.LogOut
        }),
        onClick: onExitContext
    }))), children);
};
